<template>
  <div>
    <div>
      <SjDropdownMenu
        @select="handleSelect"
        :menuProps="{ data: menuData1 }"
        label="菜单"
      />
    </div>
    <div style="margin-top: 10px">
      <SjDropdownMenu
        @select="handleSelect"
        :menuProps="{ data: menuData1 }"
        label="菜单 disabled"
        disabled
      />
    </div>
    <div style="margin-top: 10px">
      <SjDropdownMenu
        @select="handleSelect"
        :menuProps="{ data: menuData1 }"
        :dropdownProps="{ trigger: 'hover' }"
        label="菜单hover"
      />
    </div>
    <div style="margin-top: 10px">
      <SjDropdownMenu
        @select="handleSelect"
        :menuProps="{ data: menuData1 }"
        :showArrow="false"
        label="隐藏箭头"
      />
    </div>
    <div style="margin-top: 10px;height: 100px">
      <SjDropdownMenu
        @select="handleSelect"
        :menuProps="{ data: menuData1 }"
        :showArrow="false"
      >
        <i class="icon_com comicon_blankdata" />
      </SjDropdownMenu>
    </div>
    <div style="margin-top: 10px">
      <div class="hover_item">
        <span>hover</span>
        <SjDropdownMenu
          @select="handleSelect"
          :menuProps="{ data: menuData1 }"
          :showArrow="false"
        >
          <div class="inner_item">trigger</div>
        </SjDropdownMenu>
      </div>
    </div>

    <div style="margin-top: 10px">
      <div class="hover_item1">
        <span>hover</span>
        <SjDropdownMenu
          @select="handleSelect"
          class="hover_dropdown"
          :dropdownProps="{ appendToBody: true }"
          :menuProps="{ data: menuData1 }"
          :showArrow="false"
        >
          <div class="inner_item1">trigger</div>
        </SjDropdownMenu>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      menuData1: [
        {
          key: "1",
          label: "列表内容1"
        },
        {
          key: "2",
          label: "列表内容2",
          extra: "F2"
        },
        {
          key: "3",
          label: "列表内容3列表内容3列表内容3列表内容3列表内容3",
          extra: "F3"
        },
        {
          key: "4",
          label: "列表内容4",
          disabled: true
        }
      ]
    };
  },
  methods: {
    handleSelect(val) {
      alert(`selected: ${val}`);
    }
  }
};
</script>

<style scoped lang="less">
.hover_item {
  height: 30px;
  width: 100px;
  background-color: blue;
  &:hover {
    background-color: fade(blue, 50%);
  }
}
.hover_item1 {
  height: 30px;
  width: 100px;
  background-color: blue;
  &:hover {
    opacity: 0.5;
  }
}
</style>
